import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import NavList from './SideNav/NavList'
import UserMenu from './SideNav/UserMenu'
import FlexAlignCenter from '../styled/FlexAlignCenter'
import { toggleStudentAnnouncementsSidebar } from '../../actions/announcements'
import AnnouncementsActiveSvg from 'static/images/Announcements/asset_announcments_active.svg'
import AnnouncementsInactiveSvg from 'static/images/Announcements/asset_announcments_inactive.svg'

const AnnouncementsActiveIcon = styled.img.attrs({
  src: AnnouncementsActiveSvg
})`
  width: 37px;
  height: 37px;
`

const AnnouncementsInactiveIcon = styled.img.attrs({
  src: AnnouncementsInactiveSvg
})`
  width: 37px;
  height: 37px;
`

export const SideNav = ({
  dispatch,
  auth,
  organizationId,
  displayStudentSidebar,
  unreadAnnouncementsCount,
  unreadFeedbackCount,
  unreadAssessmentCount,
  needsMentorDashboardRefresh,
  mentorDashboardNotificationsCount,
  pathname,
  selectedMyStudentsTab,
  collapsed,
  toggleCollapse
}) => {
  const { user } = auth

  const AnnouncementsIcon =
    unreadAnnouncementsCount > 0
      ? AnnouncementsActiveIcon
      : AnnouncementsInactiveIcon

  return auth.isAuthenticated ? (
    <nav className={collapsed ? 'collapsed printer-hide' : 'printer-hide'}>
      <div
        className="toggle-tab"
        tabIndex={collapsed ? '0' : ''}
        aria-label="Expand Navigation"
        onClick={toggleCollapse}
        onKeyPress={toggleCollapse}
      >
        <div
          className={`hamburger hamburger--squeeze js-hamburger${
            collapsed ? '' : ' is-active'
          }`}
        >
          <div className="hamburger-box">
            <div className='hamburger-inner'/>
          </div>
        </div>
      </div>

      <a
        tabIndex="-1"
        href={
          auth.isMentor
            ? auth.userHasCurrentCourses
              ? '/mystudents/journeyoverview'
              : auth.userHasPastCourses
              ? '/mentordashboard'
              : '/mycommunity'
            : `/user/${user.id}/dashboard`
        }
      >
        <div className='header-logo' role='img' aria-label='Home'/>
      </a>

      <div
        style={{
          position: 'absolute',
          top: '74px',
          left: '0',
          height: '1px',
          background: '#151f28',
          width: '100%'
        }}
        />

      <NavList
        auth={auth}
        dispatch={dispatch}
        onItemClick={toggleCollapse}
        pathname={pathname}
        unreadFeedbackCount={unreadFeedbackCount}
        unreadAssessmentCount={unreadAssessmentCount}
        needsMentorDashboardRefresh={needsMentorDashboardRefresh}
        mentorDashboardNotificationsCount={mentorDashboardNotificationsCount}
        selectedMyStudentsTab={selectedMyStudentsTab}
      />

      {!auth.isMentor && (
        <FlexAlignCenter
          style={{
            padding: '20px 0',
            position: 'absolute',
            justifyContent: 'center',
            bottom: '75px',
            height: '67px',
            width: '100%',
            borderTop: '1px solid rgba(21, 31, 40, 1)'
          }}
        >
          <AnnouncementsIcon
            style={{
              cursor: 'pointer'
            }}
            onClick={e => {
              e.preventDefault()
              e.stopPropagation()
              dispatch(
                toggleStudentAnnouncementsSidebar(!displayStudentSidebar)
              )
            }}
            />
        </FlexAlignCenter>
      )}

      <div className='user-border'/>
      <UserMenu
        dispatch={dispatch}
        auth={auth}
        organizationId={organizationId}
      />
    </nav>
  ) : null
}

SideNav.propTypes = {
  auth: PropTypes.object,
  dispatch: PropTypes.func,
  pathname: PropTypes.string,
  organizationId: PropTypes.number,
  userCourse: PropTypes.array,
  unreadAnnouncementsCount: PropTypes.number,
  unreadFeedbackCount: PropTypes.number,
  unreadAssessmentCount: PropTypes.number,
  needsMentorDashboardRefresh: PropTypes.bool,
  mentorDashboardNotificationsCount: PropTypes.number,
  selectedMyStudentsTab: PropTypes.string
}

export const mapStateToProps = state => ({
  auth: state.auth,
  pathname: state.router.location.pathname,
  organizationId: state.organization.orgId,
  userCourses: state.usercourses.currentUserCourses,
  displayStudentSidebar: state.announcements.displayStudentSidebar,
  unreadAnnouncementsCount: state.announcements.unreadCount,
  unreadFeedbackCount: state.myquests.unreadFeedbackCount,
  unreadAssessmentCount: state.myartifacts.unreadAssessmentCount,
  mentorDashboardNotificationsCount:
    state.mentordashboard.totalNotificationsCount,
  needsMentorDashboardRefresh: state.mentordashboard.needsRefresh,
  selectedMyStudentsTab: state.mystudents.selectedTab
})

export default connect(mapStateToProps)(SideNav)
